import { useState } from "react";
import { Upload, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { resolveAsset } from "../hooks/useSiteContent";

export default function ImageField({ value, onChange, testid = "image" }) {
  const [uploading, setUploading] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Imagen subida");
    } catch { toast.error("Error al subir la imagen"); } finally { setUploading(false); }
  };
  const inp = "w-full border border-ink/15 bg-[color:var(--bg)] px-3.5 py-2.5 outline-none focus:border-gold transition-colors text-sm";
  return (
    <div className="flex gap-4 items-start">
      <div className="w-20 h-20 bg-surface border border-ink/10 shrink-0 overflow-hidden flex items-center justify-center">
        {value ? <img src={resolveAsset(value)} alt="preview" className="w-full h-full object-cover" /> : <span className="text-ink/30 text-[10px] font-mono text-center px-1">sin imagen</span>}
      </div>
      <div className="flex-1 space-y-2">
        <div className="relative">
          <Link2 className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink/40" />
          <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Pega una URL o sube un archivo" data-testid={`${testid}-url`} className={`${inp} pl-9`} />
        </div>
        <label data-testid={`${testid}-upload`} className="inline-flex items-center gap-2 px-4 py-2 border border-ink/15 hover:border-gold hover:text-gold transition-colors cursor-pointer text-sm">
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Subir desde mi dispositivo
          <input type="file" accept="image/*" className="hidden" onChange={upload} />
        </label>
      </div>
    </div>
  );
}
